import { useMsal } from "@azure/msal-react";
import React, { useEffect } from "react";
import { b2cPolicies, protectedResources } from "../../authConfig";
import { useNavigate } from "react-router-dom";
import { LoadingPanel } from "../../shared/components/LoadingPanel";

export const RedirectPage = () => {
  const { instance } = useMsal();
  const navigate = useNavigate();
  const isAuthenticated = instance.getActiveAccount() !== null;

  useEffect(() => {
    if(!isAuthenticated){
        instance
        .acquireTokenSilent({
          scopes: [...protectedResources.api.scopes.read],
          authority: b2cPolicies.authorities.signUpSignIn.authority,
        })
        .then((response) => {
          localStorage.setItem(`token`, response?.accessToken);
        })
        .catch((e) => {
          localStorage.clear();
          let signUpSignInFlowRequest = {
            authority: b2cPolicies.authorities.signUpSignIn.authority,
            scopes: [...protectedResources.api.scopes.read],
          };
          instance
            .loginRedirect(signUpSignInFlowRequest)
            .catch((error) => console.log(error));
        });
    } else{
        navigate('/')
    }

  }, []);

  return <><LoadingPanel /></>;
};
